// ENV VARS //
const theme = process.env.VUE_APP_THEME || "virtualoffice";

const exportTheme = {
  virtualoffice: {
    "name": "Virtualoffice",
    "cdnUrl": "https://cdn.virtual-office.solutions/",
    "stagingHost": "https://staging.virtual-office.solutions",
    "apiHost": "https://api.virtual-office.solutions",
    "apiVersion": "v2",
    "apiClient": "$zet&8#234-rt456",
    "version": "v4.0.0",
    "fullName": "Virtualoffice Solutions :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  golyath: {
    "name": "Golyath",
    "cdnUrl": "https://cdn.golyath.com/",
    "apiHost": "https://api.golyath.com",
    "apiVersion": "v2",
    "apiClient": "rtRGF%6588IKJ*23HgtH!6",
    "version": "v4.0.0",
    "fullName": "Golyath :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  teamsports: {
    "name": "11teamsports",
    "cdnUrl": "https://cdn.11ts-group.com/",
    "apiHost": "https://api.11ts-group.com",
    "apiVersion": "v2",
    "apiClient": "rt45-+*23HgtH!6",
    "version": "v4.0.0",
    "fullName": "11teamsports :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  avd: {
    "name": "avd",
    "cdnUrl": "https://cdn.avd.de/",
    "stagingHost": "https://staging.avd-desk.com",
    "publicHost": "https://public.avd-desk.com",
    "apiHost": "https://api.avd-desk.com",
    "apiVersion": "v2",
    "apiClient": "3HgtH!6rt45-+*2",
    "version": "v4.0.0",
    "fullName": "AvD Desk :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  tlgee: {
    "name": "tlgee",
    "cdnUrl": "https://cdn.tlgee.com/",
    "stagingHost": "https://staging.tlgee.com",
    "apiHost": "https://api.tlgee.com",
    "apiVersion": "v2",
    "apiClient": "tH!6345-:Xxwiuefghoinde",
    "version": "v4.0.0",
    "fullName": "TLGEE :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  sanopoly: {
    "name": "sanopoly",
    "cdnUrl": "https://cdn.sanopoly.com/",
    "stagingHost": "https://staging.sanopoly.com",
    "apiHost": "https://api.sanopoly.com",
    "apiVersion": "v2",
    "apiClient": "r3HgF%6!tRGKJ588ItH*26",
    "version": "v4.0.0",
    "fullName": "sanopoly :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  },
  fundw: {
    "name": "fundw",
    "cdnUrl": "https://cdn.fundw-reflexintegration.de/",
    "stagingHost": "https://staging.fundw-reflexintegration.de",
    "apiHost": "https://api.fundw-reflexintegration.de",
    "apiVersion": "v2",
    "apiClient": "rGKJ3HgF%6!tR3HgXX11R*26",
    "version": "v4.0.0",
    "fullName": "FundW :: ",
    "loader": {
      "display": true,
      "type": "default"
    },
    "scrollTop": {
      "display": false
    },
    "header": {
      "showSearch": false,
      "display": true,
      "width": "fluid",
      "fixed": {
        "desktop": true,
        "tabletAndMobile": true
      }
    },
    "megaMenu": {
      "display": false
    },
    "aside": {
      "display": true,
      "fixed": true,
      "menu": "main",
      "primaryDisplay": true,
      "secondaryDisplay": true,
      "secondaryDisplayAsHover": false,
      "toggle": false,
      "minimized": false,
      "defaultMinimized": false
    },
    "content": {
      "width": "fluid"
    },
    "toolbar": {
      "display": true,
      "width": "fluid",
      "breadcrumb": true
    },
    "sidebar": {
      "display": false,
      "toggle": true,
      "shown": false,
      "content": "general",
      "bgColor": "bg-info",
      "displayFooter": true,
      "displayFooterButton": true
    },
    "footer": {
      "width": "fluid"
    }
  }
};

// DEV License Options — dynamisch aus vorhandenen Theme-Configs
const themeToLicense: Record<string, string> = {
  teamsports: '11teamsports',
};

export const devLicenseOptions = [
  ...Object.entries(exportTheme).map(([key, config]) => ({
    value: themeToLicense[key] || key,
    label: (config as any).name || key,
  }))
];

export default exportTheme[theme];
